import ACTION from '../action_constant';
import {ajaxDeleteWithToken,ajaxPost,ajaxGet,ajaxPostWithToken,ajaxGetWithToken} from '../util/ajax';
import API from '../api_config';
import cookie from '../util/cookie';

const addTripsActions = {
  addTrip: (paramObj) =>{
    return (dispatch) =>{
      return ajaxPostWithToken({
          url : API.addTrips,
          data: paramObj,
          success: (data) => {
          },
          error: (error) => {
          }
      })
    }
  },
  getAllTrips: (url_params) => {
      return (dispatch) => {
          return ajaxGetWithToken ({
              url: API.getAllTrips + '?count=' + url_params.count+ '&offset=' + url_params.offset,
              success: (successData) => {
                dispatch({
                  type: ACTION.TRIPS.GET_ALL_TRIPS,
                  data :successData
                });
              },
              error: (error) =>{

              }
          })
      }
  },
  updateTrip: (paramObj) =>{
    return (dispatch) =>{
      return ajaxPostWithToken({
          url : API.updateTrip,
          data: paramObj,
          success: (data) => {
            dispatch({
              type: ACTION.TRIPS.UPDATE_TRIP,
              data
            })
          },
          error: (error) => {
          }
      })
    }
  },
  deleteTrip:(tripId) =>{
    return function(dispatch){
      return ajaxDeleteWithToken({
        url : API.deleteTrip+ '?tripId=' + tripId,
        success: () => {
          dispatch({
            type: ACTION.TRIPS.DELETE_TRIP,
            tripId
          });
        },
        error: (error) => {
        }
      });
    }
  },
  clearAllTrips : () =>{
    return function(dispatch){
          dispatch({
            type: ACTION.TRIPS.CLEAR_TRIPS,
            data : []
          })
      }
    }
}

export default addTripsActions;



// WEBPACK FOOTER //
// app/add_trips/add_trips_actions.jsx